/**
 * Feature flag keys enum
 */
export enum FlagKeys {
  IsolatedMargin = "isolated-margin",
}
